import { Link } from "react-router-dom";
import PolicyShell from "../../../components/policy/PolicyShell";


const CCBILL_URL =
    "https://www.ccbillcomplaintform.com/ccbill/form/CCBillContentRemovalRequest1/formperma/sBK2jfIoZWAFw2hRRt5Rv2PQncscFzpvOH6bPcwopas";

const ComplaintsPolicy = () => (
    <PolicyShell title="Complaints & Content Removal Policy" updated="October 2026">
        <section>
            <h2 className="text-lg font-semibold mb-3">1. Reporting Content</h2>
            <p className="mb-2">
                Anyone may report content that may be illegal or that otherwise violates our{' '}
                <Link className="underline" to="/community-guidelines">Community Standards</Link>,
                including non-consensual content, deep fakes, impersonation, and suspected
                trafficking or exploitation.
            </p>
            <ul className="list-disc list-inside space-y-1 ml-2">
                <li>Email: <a className="underline" href="mailto:support@tlknow.ai">support@tlknow.ai</a></li>
                <li>
                    Form:{' '}
                    <Link  className="underline" to={CCBILL_URL} target="_blank" rel="noopener noreferrer">
                        complaints / take down request
                    </Link>
                </li>
            </ul>
            <p className="mt-2">
                Please include the page URL, a description of the content, and why you believe
                it should be removed.
            </p>
        </section>
        <section>
            <h2 className="text-lg font-semibold mb-3">2. Review Timeline</h2>
            <p>
                All reported complaints will be reviewed and resolved within five (5) business
                days of receipt. You will be notified of the outcome.
            </p>
        </section>
        <section>
            <h2 className="text-lg font-semibold mb-3">3. Review Process</h2>
            <ol className="list-decimal list-inside space-y-1 ml-2">
                <li>We acknowledge your complaint and log it.</li>
                <li>Content that is clearly illegal or poses immediate harm may be hidden while we review it.</li>
                <li>A member of our team assesses the content against applicable law and our Community Standards.</li>
                <li>We notify you and, where appropriate, the account holder of the decision and the reasons for it.</li>
            </ol>
        </section>
        <section>
            <h2 className="text-lg font-semibold mb-3">4. Possible Outcomes</h2>
            <ul className="list-disc list-inside space-y-1 ml-2">
                <li>Content removed</li>
                <li>Content restricted or edited</li>
                <li>Warning, suspension, or termination of the responsible account or creator</li>
                <li>Referral to law enforcement or other authorities where required</li>
                <li>No action, where the content is found to comply with the law and our standards</li>
            </ul>
        </section>
        <section>
            <h2 className="text-lg font-semibold mb-3">5. Appeals</h2>
            <p className="mb-2">
                If you disagree with a decision, you may appeal by replying to the decision
                email or writing to support@tlknow.ai within 14 days. Appeals are
                reviewed by someone who was not involved in the original decision, and
                decided within five (5) business days.
            </p>
            <p>
                If a disagreement remains after the appeal, it may be referred to an
                independent, neutral reviewer. TLK bears the cost of that review.
            </p>
        </section>
        <section>
            <h2 className="text-lg font-semibold mb-3">6. Removal Requests by Depicted Persons</h2>
            <p className="mb-2">
                Any person depicted in content on TLK may ask for that content to be removed
                and may appeal the outcome. This applies to a person's image, likeness, or voice,
                including AI-generated depictions.
            </p>
            <ul className="list-disc list-inside space-y-1 ml-2">
                <li>Submit a request using the email or form in Section 1, stating that you are the person depicted.</li>
                <li>We will review the request within five (5) business days.</li>
                <li>
                    Content is removed where the review finds that consent was not given, or
                    that consent is void or invalid under applicable law.
                </li>
                <li>
                    Disagreements about the outcome follow the appeal process in Section 5,
                    including review by a neutral body at TLK's expense.
                </li>
            </ul>
        </section>
        <section>
            <h2 className="text-lg font-semibold mb-3">7. Related Policies</h2>
            <p>
                See our <Link className="underline" to="/anti-trafficking-policy">Anti-Trafficking Policy</Link>,{' '}
                <Link className="underline" to="/community-guidelines">Community Standards</Link>, and{' '}
                <Link className="underline" to="/user/privacy">Privacy Policy</Link>.
            </p>
        </section>
    </PolicyShell>
);

export default ComplaintsPolicy;